import { VoyagerInput } from '@core/reducers/inputsSlice';

import styles from './ProductTags.module.css';

interface ProductTagsProps {
  importantFactors?: VoyagerInput;
}

const ProductTags = ({ importantFactors }: ProductTagsProps) => {
  if (!importantFactors?.options) {
    return null;
  }

  let factors: { label: string }[] = importantFactors?.options.slice(0, 2) ?? [];
  // Check if any of the factors have a label longer than 13 characters
  const longFactors: { label: string }[] = factors.filter((factor) => factor.label.length > 13);
  // If there are long factors, slice the array to only include the first one
  if (longFactors.length > 0) {
    factors = factors.slice(0, 1);
  }

  return (
    <div className={styles.tagsContainer}>
      <span className={styles.tagContent}>
        {factors.map((value: { label: string }) => (
          <div className={styles.tag} key={value.label}>
            {value.label}
          </div>
        ))}
      </span>
    </div>
  );
};

export default ProductTags;
